import React from 'react'
import customer from "../../imagens/customers/customer.png"
import customer2 from "../../imagens/customers/customer2.png"
import customer3 from "../../imagens/customers/customer3.png"
import customer4 from "../../imagens/customers/customer4.png"
import customer5 from "../../imagens/customers/customer5.png"
import customer6 from "../../imagens/customers/customer6.png"
import customer7 from "../../imagens/customers/customer7.png"
import customer8 from "../../imagens/customers/customer8.jpg"
import customer9 from "../../imagens/customers/customer9.png"
import customer10 from "../../imagens/customers/customer10.png"
import customer11 from "../../imagens/customers/customer11.png"
import customer12 from "../../imagens/customers/customer12.jpg"
import customer13 from "../../imagens/customers/customer13.jpg"
import customer14 from "../../imagens/customers/customer14.jpg"
import customer15 from "../../imagens/customers/customer15.jpg"
import customer16 from "../../imagens/customers/customer16.jpg"
import customer18 from "../../imagens/customers/customer18.jpg"
import customer19 from "../../imagens/customers/customer19.png"
import customer20 from "../../imagens/customers/customer20.png"
import customer21 from "../../imagens/customers/customer21.png"
import customer22 from "../../imagens/customers/customer22.png"
import customer23 from "../../imagens/customers/customer23.png"
import customer24 from "../../imagens/customers/customer24.png"
import customer25 from "../../imagens/customers/customer25.jpg"
import customer26 from "../../imagens/customers/customer26.png"
import customer27 from "../../imagens/customers/customer27.png"
import Header from '../../Components/Header'
import Customers from '../../Components/customers'



const listCustomer = [
    {
        img: customer
    },
    {
        img: customer2
    },
    {
        img: customer3
    },
    {
        img: customer4
    },
    {
        img: customer5
    },
    {
        img: customer6
    },
    {
        img: customer7
    },
    {
        img: customer8
    },
    {
        img: customer9
    },
    {
        img: customer10
    },
    {
        img: customer11
    },
    {
        img: customer12
    },
    {
        img: customer13
    },
    {
        img: customer14
    },
    {
        img: customer15
    },
    {
        img: customer16
    },
    {
        img: customer18
    },
    {
        img: customer19
    },
    {
        img: customer20
    },
    {
        img: customer21
    },
    {
        img: customer22
    },
    {
        img: customer23
    },
    {
        img: customer24
    },
    {
        img: customer25
    },
    {
        img: customer26
    },
    {
        img: customer27
    },
]






const CustomersPage = () => {
return (
    <div>
        <Header/>
            <Customers
                listCustomer = {listCustomer}
            />
    </div>
)
}

export default CustomersPage